import { SVGProps, Ref, forwardRef } from 'react';

export const GraduationHatOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.6 11.006 0 8.928 12 2l12 6.928-3.6 2.078c.08.741.097 1.482.1 2.124-.009 1.569-.105 3.719-.982 5.01-.394.581-1.345 1.223-2.852 2.094-2.035 1.177-3.346 1.766-4.654 1.77h-.026c-1.308-.004-2.618-.594-4.652-1.77-1.507-.871-2.458-1.513-2.852-2.094-.881-1.299-.974-3.465-.982-5.036.003-.636.021-1.367.1-2.098m1.728.997c-.058 1.147-.054 2.318.116 3.455.118.797.31 1.35.527 1.672.14.197.378.349.57.487.402.288.954.63 1.694 1.059 2.055 1.188 2.983 1.525 3.755 1.528h.017c.773-.002 1.7-.339 3.758-1.528.74-.428 1.293-.77 1.693-1.059.193-.138.43-.29.57-.487.217-.32.408-.869.527-1.659.171-1.141.175-2.316.117-3.468L12 15.855zM12 13.777l-8.4-4.85L12 4.079l8.4 4.85z"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
GraduationHatOutlinedSize24Glyph.displayName = 'GraduationHatOutlinedSize24Glyph';
